export const MOTOR_TECHNOLOGY_DROPDOWN = '121';
export const MOTOR_EFFICIENCY_INPUT = '140';
export const SWITCHGEAR_DESIGN_TYPE_DROPDOWN = '220';
export const SWITCHGEAR_PRIMARY_POWER_LOSS = '230';
export const SWITCHGEAR_SECONDARY_POWER_LOSS = '231';
export const CONVERTER_DESIGN_TYPE_DROPDOWN = '320';
